import React from 'react'
import ReactDOM from 'react-dom/client'
import { initializeSentry } from './shared/utils/sentry'
import { initializeClarity } from './shared/utils/clarity'
import ErrorBoundary from './shared/components/ErrorBoundary'
import App from './App'
import './index.css'

// Initialize Sentry before rendering
initializeSentry()

// Initialize Microsoft Clarity
initializeClarity()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)

